import { modelType } from "./types";

export const SELECTED_TEXT_CHARACTER_LIMIT = 10000;

// Legacy exports for backward compatibility - these will be deprecated
export const openAiModels: modelType[] = [
  {
    name: "GPT-4o",
    value: "gpt-4o",
    modelId: 1,
  },
  {
    name: "GPT-4o mini",
    value: "gpt-4o-mini",
    modelId: 2,
  },
];

export const mistralModels: modelType[] = [
  {
    name: "Mistral Large",
    value: "mistral-large-latest-2407",
    modelId: 3,
  },
  {
    name: "Pixtral 12B",
    value: "pixtral-12b-2409",
    modelId: 4,
  },
];